(function () {
  'use strict';

  function boot() {
    var sections = document.querySelectorAll('.wh-info-cards');
    if (!sections.length) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (sec) {
      if (reduce) {
        sec.classList.add('wh-info-cards--in-view');
        return;
      }

      var io = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('wh-info-cards--in-view');
            observer.unobserve(entry.target);
          });
        },
        { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      io.observe(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
